// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_mr-0";
export var animationContainer = "_mr-1";
export var itemPrice = "_mr-a";
export var itemizedContent = "_mr-9";
export var itemizedHeader = "_mr-7";
export var itemizedRow = "_mr-8";
export var itemizedSection = "_mr-6";
export var modalContent = "_mr-2";
export var orderName = "_mr-3";
export var refundOption = "_mr-4";
export var refundOptionsContainer = "_mr-5";
export var shippingLabel = "_mr-b";
export var totalRow = "_mr-c";